import { Menu } from "primereact/menu";
import MeaButton from "../../../../components/MeaButton";
import { PERMISSION_SCHOOL_TRAININGS, PERMISSION_TRAINING_TASKS } from "../../../../permissions";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import UpdateTrainingModal from "./UpdateTrainingModal";
import { ProgressSpinner } from "primereact/progressspinner";
import { useAuthContext } from "../../../../hooks/useAuthContext";

const TrainingHeader = ({ training, query }) => {
  //
  const { reloadCurrentTraining, hasPermission } = useAuthContext();

  const navigate = useNavigate();

  const updateModalRef = useRef();

  const actions =
    [
      {
        label: "Modifier",
        icon: "pi pi-file-edit",
        disable: !hasPermission(PERMISSION_SCHOOL_TRAININGS.UPDATE),
        command: () => {
          updateModalRef.current.show(() => {
            query.refetch();
            reloadCurrentTraining();
          });
        },
      },
      {
        separator: true,
        disable: !hasPermission(PERMISSION_TRAINING_TASKS.IMPORT_FROM_TRAINING),
      },
      {
        label: "Importer",
        icon: "pi pi-file-edit",
        disable: !hasPermission(PERMISSION_TRAINING_TASKS.IMPORT_FROM_TRAINING),
        command: () => {
          navigate("/school/" + training?.school_id + "/admin/trainings/" + training?.id + "/import");
        },
      }
    ]

  const actionsMenu = useRef(null);
  const filteredActions = actions.filter(item => !item.disable);

  return (
    <div>
      <UpdateTrainingModal ref={updateModalRef} schoolId={training?.school_id} training={training} />
      {(query.isLoading && <div className="p-2"><ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" /></div>) || (query.isError && <div className="p-5">Error: {query.error.message}</div>) || (
        <div className="surface-ground px-3 py-3 md:px-6 lg:px-5 flex align-items-start justify-content-between flex-row">

          <div className="w-full md:w-6">
            <span className="inline-flex align-items-center text-900 text-2xl font-medium mb-3">
              {training?.name}
            </span>
            <div className="flex align-items-center text-600">
              <span className="mr-5">
                <i className="pi pi-chevron-circle-right mr-2"></i>De {training?.start_courses_date ? new Date(training?.start_courses_date).toLocaleDateString("fr-FR") : "-"} à {training?.end_courses_date ? new Date(training?.end_courses_date).toLocaleDateString("fr-FR") : "-"}
              </span>
              {/* <span>
              <i className="pi pi-book mr-2"></i>60 Cases
            </span> */}
            </div>
          </div>
          <div>
            <Menu
              model={filteredActions || []}
              popup
              ref={actionsMenu}
              id="popup_actions_menu"
            />
            <MeaButton
              //label="Actions"
              text
              raised
              icon="pi pi-cog"
              className="mr-2"
              onClick={(event) => actionsMenu.current.toggle(event)}
              aria-controls="popup_actions_menu"
              aria-haspopup
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default TrainingHeader;
